import { useMutation } from '@tanstack/react-query';
import {
  type Forms_SubmitFormInput,
  type UseQueryReturnType,
  gqlClient,
  graphql,
  queryClient,
} from '@tyro/api';
import { formsKeys } from '@tyro/forms';
import { infoRequestKeys } from './keys';

const saveForm = graphql(/* GraphQL */ `
  mutation forms_submitInformationRequestForms($input: Forms_SubmitFormInput!) {
    forms_submitInformationRequestForms(input: $input) {
      id {
        provider
        forPartyId
        objectId
      }
      globalId
      success
      validations {
        fieldErrors
        globalErrors
      }
    }
  }
`);

export function useSaveForm() {
  return useMutation({
    mutationFn: (input: Forms_SubmitFormInput) =>
      gqlClient.request(saveForm, { input }),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: infoRequestKeys.all }),
        queryClient.invalidateQueries({ queryKey: formsKeys.all }),
      ]);
    },
  });
}

export type ReturnTypeFromUseSaveForm = UseQueryReturnType<typeof useSaveForm>;
